import { nanoid } from 'nanoid';

export const getDeviceId = () => {
  const deviceId = localStorage.getItem('device_id');

  if (deviceId) {
    return deviceId;
  }

  const newDeviceId = nanoid();
  localStorage.setItem('device_id', newDeviceId);

  return newDeviceId;
};
